exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-group-addon{\r\n    min-width: 41px;\r\n}\r\n.page-header{\r\n    padding-top: 9px;\r\n}\r\n\r\n.inner-check-wrapper .CheckAmountDiv {\r\n    right: 2.5em;\r\n    top: 7.8em;\r\n}\r\n\r\n.bankName_sub{\r\n    top: 14.5em;\r\n    left: 2.1em;\r\n    width: 300px;\r\n}\r\n.bankName_sub span{\r\n    font-size: 10px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/generate-bankauth-url/generate-bankauth-url.component.css
// module id = ../../../../../src/app/generate-bankauth-url/generate-bankauth-url.component.css
// module chunks = main